import React from 'react';
import PropTypes from 'prop-types';
import { Link, withRouter } from 'react-router-dom';
import JBImage from 'components/essentials/JBImage';
import getSubcategories from './getSubcategories';
import ShopPageList from './ShopPageList';

const ShopPageCategoryPanel = ({
  className = '',
  customPanelContent,
  image,
  inspirationPath,
  name,
  path,
  subcategories = getSubcategories(name),
}) => (
  <div
    className={`overflow-hidden md:border-[1px] md:border-gray-light6 md:rounded-lg ${className}`}
  >
    {image && (
      <Link to={path}>
        <JBImage
          className="w-full max-[767px]:hidden"
          src={image}
          width={500}
          alt={name}
        />
      </Link>
    )}

    {customPanelContent || (
      <ShopPageList {...{ name, path, subcategories, inspirationPath }} />
    )}
  </div>
);

ShopPageCategoryPanel.propTypes = {
  className: PropTypes.string,
  customPanelContent: PropTypes.string,
  image: PropTypes.string,
  inspirationPath: PropTypes.string,
  name: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
  subcategories: PropTypes.array,
};

export default withRouter(ShopPageCategoryPanel);
